/* eslint-disable import/prefer-default-export */

import { createContext } from 'react';

export const CloseConfirmationModalContext = createContext();
export const ConfettiContext = createContext();
export const OrderNewContext = createContext();
